'use strict'

import React      from 'react'
import _          from 'lodash'
import API        from '../services/api'
import $          from 'jquery'
import ButtonPage from '../assets/button-page'

export default class DentalHistory extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      treatmentOptions: [],
      treatmentSelectExpanded: false,
      showOptions: false
    }
  }

  componentWillMount () {
    let api = new API()
    api.getTreatmentOptions().then((result) => {
      this.setState({
        treatmentOptions: result
      })
    })
  }

  resizeButtons () {
    let highest = 0
    let highestEl = null

    $('.button-page label.button').each(function (i) {
      if ($(this).height() > highest) {
        highest = $(this).height()
        highestEl = this
      }
    })

    $('.button-page label.button').not(highestEl).height(highest)
  }

  toggleTreatmentSelectExpanded () {
    this.setState({
      treatmentSelectExpanded: !this.state.treatmentSelectExpanded
    }, () => this.resizeButtons())
  }

  dentistVisit (val) {
    const { onChange } = this.props

    onChange('last-visit', {
      displayName: 'Dental History',
      value: val,
      pageRef: 'dental-history',
      order: 5,
      displayInSummary: true
    })
  }

  knowWhatsNeeded (hasValue, e) {
    const { onChange, summary } = this.props

    let currentSummary = summary['know-whats-needed']
    let values = currentSummary && currentSummary.value !== 'No' ? currentSummary.value : []

    if (hasValue) {
      if (e.target.type === 'checkbox') {
        if (e.target.checked) {
          values.push(e.target.name)
        } else {
          values = _.reject(values, value => {
            return value === e.target.name
          })
        }
      }
    } else {
      values = 'No'
    }

    this.setState({
      showOptions: hasValue
    })

    onChange('know-whats-needed', {
      displayName: 'Treatment Interested',
      value: values,
      pageRef: '',
      order: 6,
      displayInSummary: true
    })
  }

  render () {
    const {treatmentOptions, treatmentSelectExpanded} = this.state

    const { summary } = this.props

    let activeValue = summary['know-whats-needed'] ? summary['know-whats-needed'].value : ''

    return (
      <section className='dental-history'>
        <p className='align-center'>
          Please let us know a little more about you.
        </p>
        <br />
        <h2 className='header'>Dental History</h2>
        <div>
          <div className='input-row'>
            <span className='two-thirds-width item-title'>Seen the dentist in the last 2 years?</span>
            <div className='one-third-width flex-wrapper'>
              <div className='half-width-no-responsiveness flex-items'>
                <input
                  type='radio'
                  id='dentist-past-12-months_yes'
                  name='dentist-past-12-months'
                  checked={summary['last-visit'] && summary['last-visit'].value === 'Less than 2 years'}
                  onClick={this.dentistVisit.bind(this, 'Less than 2 years')} />
                <label htmlFor='dentist-past-12-months_yes' className='required'>
                  Yes
                </label>
              </div>
              <div className='half-width-no-responsiveness flex-items'>
                <input
                  type='radio'
                  id='dentist-past-12-months_no'
                  name='dentist-past-12-months'
                  checked={summary['last-visit'] && summary['last-visit'].value !== 'Less than 2 years'}
                  onClick={this.dentistVisit.bind(this, 'More than 2 years')} />
                <label htmlFor='dentist-past-12-months_no'>
                  No
                </label>
              </div>
            </div>
          </div>
          <div className='input-row know-whats-needed'>
            <span className='two-thirds-width item-title'>Know the dental treatment you need?</span>
            <div className='one-third-width flex-wrapper'>
              <div className='half-width-no-responsiveness flex-items'>
                <input
                  type='radio'
                  id='know-whats-needed_yes'
                  className='know-whats-needed_yes'
                  name='know-whats-needed'
                  value='yes'
                  checked={summary['know-whats-needed'] && summary['know-whats-needed'].value !== 'No'}
                  onClick={this.knowWhatsNeeded.bind(this, true)} />
                <label htmlFor='know-whats-needed_yes'>
                  Yes
                </label>
              </div>
              <div className='half-width-no-responsiveness flex-items'>
                <input
                  type='radio'
                  id='know-whats-needed_no'
                  name='know-whats-needed'
                  value='No'
                  checked={summary['know-whats-needed'] && summary['know-whats-needed'].value === 'No'}
                  onClick={this.knowWhatsNeeded.bind(this, false)} />
                <label htmlFor='know-whats-needed_no'>
                  No
                </label>
              </div>
            </div>
          </div>
          <div className={`input-row treatment-select ${this.state.showOptions ? 'show' : ''}`}>
            <div className={`full-width treatment-selection ${treatmentSelectExpanded ? 'expanded' : ''}`}>
              <div className='full-width item-title' onClick={this.toggleTreatmentSelectExpanded.bind(this)}>
                Select your treatments
              </div>
              <ButtonPage
                reference='name'
                multiple='true'
                buttons={treatmentOptions}
                onClick={this.knowWhatsNeeded.bind(this, true)}
                value={summary['know-whats-needed'] && summary['know-whats-needed'].value}
                activeValue={activeValue} />
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/form-segments/dental-history.js